import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Card from '@/views/dashboard/_components/card/card.vue'
import ApprovalSectionCard from './approval-section-card.vue'
import DeploySectionCard from './deploy-section-card.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'approval-deploy-control',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(Card, {
    size: "first",
    border: "",
    "background-color": "var(--cm-color-card-bg)",
    title: _ctx.$t('overviewZone.approvalDeployTitle'),
    description: _ctx.$t('overviewZone.approvalDeployDesc'),
    class: "approval-deploy-control-wrap"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 16 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 14 }, {
            default: _withCtx(() => [
              _createVNode(ApprovalSectionCard)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 10 }, {
            default: _withCtx(() => [
              _createVNode(DeploySectionCard)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "description"]))
}
}

})